import { z } from "zod";

export const EntregaObraClienteReportFotoSchema = z.object({
    retrabalho: z.array(z.string()).optional().nullable().default(null),

});

export type EntregaObraClienteReportFotoForm = z.infer<typeof EntregaObraClienteReportFotoSchema>;

export const defaultEntregaObraClienteReportFotoForm: Partial<EntregaObraClienteReportFotoForm> = {
    retrabalho: [],
};


